import { io } from "socket.io-client";
import ACTIVE_SERVER from "../services/config";

export const connectionClass = {
    socketInfo: io(ACTIVE_SERVER.serverAddress, {
        path: "/socket.io",
        // transports: ["websocket"],
        // secure: true,
        reconnection: true,
        // methods: ["GET", "POST"],
        upgrade: false,
        autoConnect: true
        // rejectUnauthorized: false
    }),

}

connectionClass.socketInfo.on("error", (err) => {
    console.log("ERR")
})